import { render, staticRenderFns } from "./SearchMaterial.vue?vue&type=template&id=0d187523"
import script from "./SearchMaterial.vue?vue&type=script&lang=js"
export * from "./SearchMaterial.vue?vue&type=script&lang=js"
import style0 from "./SearchMaterial.vue?vue&type=style&index=0&id=0d187523&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports